/* eslint-disable */
export default function (payload) {
  return `${payload} | ${process.env.APP_DOMAIN};`
}
